import DotNetObject = DotNet.DotNetObject;
import { WebUser } from '@crimsontide/core/client/interfaces';

export const WebUserService = (() => {
  let dotNetObj: DotNetObject;
  let cachedWebUsers: WebUser[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getWebsiteWebUsers = async (useCache: boolean = true): Promise<WebUser[]> => {
    if (useCache && cachedWebUsers != null)
      return cachedWebUsers;

    if (dotNetObj) {
      cachedWebUsers = await dotNetObj.invokeMethodAsync<WebUser[]>('GetWebsiteWebUsersAsync');
      return cachedWebUsers;
    } else {
      throw 'Web User DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getWebsiteWebUsers,
  };
})();
